<template>
  <el-dialog :visible="visible" @close="$emit('update:visible', false)" class="dialog-w40">
    <h2 class="text-center mt-0">История статусов</h2>
    <div class="text-center mt-2">Время смены статуса отображается по Москве</div>

    <div class="mt-2 card-table card-table_border" v-loading="fetchStatusHistoryProgress">
      <div class="grid-table grid-table_border">
        <div v-for="(status, ind) of statusHistory" :key="ind" class="grid-table__row">
          <p>{{dateFormatToMoscowTime(status.creationDate)}}</p>
          <p>{{status.status}}</p>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { dateFormatToMoscowTime } from '@/commons/helpers';

export default {
  props: {
    visible: Boolean,
    item: Object,
  },
  created() {
    this.fetchStatusHistory();
  },
  computed: {
    ...mapGetters({
      fetchStatusHistoryProgress: 'orders/fetchStatusHistoryProgress',
      statusHistory: 'orders/statusHistory',
    }),
  },
  methods: {
    ...mapMutations({
      setStatusHistory: 'orders/setStatusHistory',
    }),
    ...mapActions({
      fetchStatusHistory: 'orders/fetchStatusHistory',
    }),
    dateFormatToMoscowTime,
  },
  destroyed() {
    this.setStatusHistory([]);
  },
};
</script>
